@if (!editMode) {
  <!-- Nicely styled link block showing metadata and actions -->
  <div class="link-display-card">
    <div class="link-display-header">
      <div class="link-display-title">{{ contentObj?.displayText || displayText || contentObj?.fileName || 'Link' }}</div>
      <div class="link-display-actions">
        <!-- Open (for PDFs or secureUrl) -->
        <button
          mat-icon-button
          color="primary"
          aria-label="Open"
          (click)="openPdfInNewTab($event)"
          *ngIf="isPdfLocal() || contentObj?.secureUrl"
        >
          <mat-icon>open_in_new</mat-icon>
        </button>
        <!-- Download -->
        <button
          mat-icon-button
          color="primary"
          aria-label="Download"
          (click)="downloadContent()"
          *ngIf="contentObj?.base64 || contentObj?.secureUrl"
        >
          <mat-icon>download</mat-icon>
        </button>
        <!-- Edit (PDF editor) -->
        <button mat-icon-button color="accent" aria-label="Edit PDF" (click)="openPdfEditor()" *ngIf="isPdfLocal()">
          <mat-icon>edit</mat-icon>
        </button>
      </div>
    </div>

    <div class="link-display-sub">
      <span class="meta-item file-name"><strong>File name:</strong>&nbsp;{{ contentObj?.fileName || '-' }}</span>
      <span class="meta-item mime"><strong>MIME:</strong>&nbsp;{{ contentObj?.mimeType || '-' }}</span>
      <span class="meta-item size" *ngIf="getSizeLabel()"><strong>File size:</strong>&nbsp;{{ getSizeLabel() }}</span>
      <span class="meta-item added" *ngIf="getAddedDateLabel()"><strong>Added date:</strong>&nbsp;{{ getAddedDateLabel() }}</span>
    </div>

    <div class="link-display-body">
      <!-- image preview with caption -->
      <ng-container *ngIf="contentObj?.mimeType && contentObj.mimeType.startsWith('image/') && dataUrl">
        <div class="embedded-image" [style.width]="imageWidthStyle">
          <img
            [src]="dataUrl"
            [alt]="contentObj.altText || contentObj.displayText || contentObj.fileName || 'Image'"
            [style.width]="'100%'"
          />
          <div class="image-caption" *ngIf="contentObj?.caption">{{ contentObj.caption }}</div>
        </div>
      </ng-container>

      <!-- pdf label / viewer trigger -->
      <ng-container *ngIf="contentObj?.mimeType && contentObj.mimeType.toLowerCase().indexOf('pdf') >= 0">
        <div class="embedded-pdf">
          <mat-icon aria-hidden="true">picture_as_pdf</mat-icon>
          <button class="pdf-open-button" mat-button type="button" (click)="openPdfEditor()" aria-label="Open PDF viewer">
            {{ contentObj.displayText || contentObj.fileName || 'Open PDF' }}
          </button>
        </div>
      </ng-container>

      <!-- fallback link -->
      <ng-container *ngIf="!contentObj?.mimeType && (displayText || fileName)">
        <span>{{ displayText || fileName }}</span>
      </ng-container>
    </div>
  </div>
} @else {
  <div class="link-edit-form">
    <mat-form-field appearance="outline" class="link-field">
      <mat-label>Display text</mat-label>
      <input matInput [value]="displayText" (input)="onDisplayTextInput($event)" placeholder="File display text" />
    </mat-form-field>

    <div class="upload-row">
      <!-- Hidden file input; triggered by the attach button -->
      <input #fileInput type="file" accept="image/*,application/pdf" hidden (change)="onFileChosen($event)" />
      <button mat-mini-fab color="primary" type="button" (click)="fileInput.click()" aria-label="Choose file">
        <mat-icon>attach_file</mat-icon>
      </button>
      @if (pendingFileName) {
        <span class="file-info">{{ pendingFileName }}</span>
        <button mat-mini-fab color="warn" type="button" class="cancel-upload" (click)="cancelUpload()" aria-label="Cancel upload">
          <mat-icon>close</mat-icon>
        </button>
      } @else {
        @if (fileName) {
          <span class="file-info">{{ fileName }}</span>
        }
      }
    </div>

    <!-- Image meta controls: shown when an image is already saved or pending -->
    @if (isImage || (pendingFileName && pendingFile && pendingFile.type.startsWith('image/'))) {
      <div class="image-meta-section">
        <mat-form-field appearance="outline" class="link-field">
          <mat-label>Alt text</mat-label>
          <input matInput [(ngModel)]="altText" placeholder="Describe the image for accessibility" />
        </mat-form-field>

        <mat-form-field appearance="outline" class="link-field">
          <mat-label>Caption</mat-label>
          <input matInput [(ngModel)]="caption" placeholder="Optional caption below image" />
        </mat-form-field>

        <div class="image-width-row">
          <label class="image-width-label">Width: {{ imageWidthPercent }}%</label>
          <input
            type="range"
            min="10"
            max="100"
            step="5"
            [(ngModel)]="imageWidthPercent"
            class="image-width-slider"
            aria-label="Image width"
          />
        </div>
      </div>
    }

    <mat-checkbox [checked]="embedInAppendix" (change)="onAppendixToggle($event.checked)">Include in appendix</mat-checkbox>

    <div class="link-actions">
      @if (contentObj && contentObj.mimeType === 'application/pdf') {
        <button mat-mini-fab color="accent" type="button" (click)="openPdfEditor()" aria-label="Edit PDF">
          <mat-icon>edit</mat-icon>
        </button>
      }
      <!-- Single save button: saves pending upload (with meta) or just meta changes for existing image -->
      @if (hasPendingFile) {
        <button mat-mini-fab color="primary" type="button" (click)="saveUpload()" aria-label="Save">
          <mat-icon>save</mat-icon>
        </button>
      } @else if (isImage) {
        <button mat-mini-fab color="primary" type="button" (click)="saveImageMeta()" aria-label="Save image settings">
          <mat-icon>save</mat-icon>
        </button>
      }
    </div>
  </div>
}
